import CreditCardIcon from '../assets/images/icons/CreditCardIcon';
import FundingIcon from '../assets/images/icons/FundingIcon';
import AlertOctagonIcon from '../assets/images/icons/AlertOctagonIcon';
import CheckSquareIcon from '../assets/images/icons/CheckSquareIcon';
import BookIcon from '../assets/images/icons/BookIcon';
import MedCaseIcon from '../assets/images/icons/MedCaseIcon';
import AddressIcon from '../assets/images/icons/AddressIcon';
import PhoneIcon from '../assets/images/icons/PhoneIcon';
import NoteIcon from '../assets/images/icons/NoteIcon';
import React from 'react';

const ClientSideBar: React.FC = () => {
  const handleOpen = () => {};

  return (
    <div className="w-14 h-full text-slate-600 ml-6 bg-white border border-slate-200  rounded-lg  flex flex-col items-center pt-8 pb-8 gap-8">
      <button onClick={handleOpen}>
        <CreditCardIcon />
      </button>
      <button onClick={handleOpen}>
        <FundingIcon />
      </button>
      <button onClick={handleOpen}>
        <AlertOctagonIcon />
      </button>
      <button onClick={handleOpen}>
        <CheckSquareIcon />
      </button>
      <button onClick={handleOpen}>
        <BookIcon />
      </button>
      <button onClick={handleOpen}>
        <MedCaseIcon />
      </button>
      <button onClick={handleOpen}>
        <AddressIcon />
      </button>
      <button onClick={handleOpen}>
        <PhoneIcon />
      </button>
      <button onClick={handleOpen}>
        <NoteIcon />
      </button>
    </div>
  );
};
export default ClientSideBar;
